// @module Eureka.MaxaPartPicker.MaxaPartPicker
define('Eureka.MaxaPartPicker.New.MaxaPartPickerMain.View'
    , [
        'PageType.Base.View',

        'MaxaPartPicker.Collection',
        'MaxaPartPicker.Collection.View',
        'eureka_maxapartpicker_newmaxapartpickermain.tpl',
        'facets_items_collection_view_cell.tpl',
        'facets_items_collection_view_row.tpl',
        'Backbone.CollectionView',
        'MaxaPartPicker.Details.View',
        'eureka_maxapartpicker_collection.tpl',
        'jQuery',
        'Configuration',
        'underscore',
        'PartPickerPagination',
        'PartPickerSort',
        'Profile.Model',
        'Backbone'

    ]
    , function (
        PageTypeBaseView,
        MaxaPartPickerCollection,
        MaxaPartPickerCollectionView,
        eureka_maxapartpicker_maxapartpickermain_tpl,
        facets_items_collection_view_cell_tpl,
        facets_items_collection_view_row_tpl,
        BackboneCollectionView,
        FacetsItemCellView,
        facets_items_collection_tpl,
        jQuery,
        Configuration,
        _,
        PartPickerPagination,
        PartPickerSort,
        ProfileModel,
        Backbone
    ) {
        'use strict';

        // @class Eureka.MaxaPartPicker.MaxaPartPicker.View @extends Backbone.View
        return PageTypeBaseView.PageTypeBaseView.extend({

            template: eureka_maxapartpicker_maxapartpickermain_tpl

            , initialize: function (options) {
                if (!window.location.hash && window.location.hash.length < 1) {
                    // hash has a value
                    console.log("No hash value, redirecting to home page")
                    window.location = SC.ENVIRONMENT.siteSettings.touchpoints.home
                }                var self = this;
                this.collection = new MaxaPartPickerCollection();
                this.profile = ProfileModel.getInstance()
                this.isLoggedIn = this.profile.attributes.isLoggedIn === "T";
                if (!self.facets) {
                    self.facets = []
                }
                this.is_logged_in = this.profile.get('isLoggedIn') === 'T' && this.profile.get('isGuest') === 'F';

                const myCallback = (event) => {
                    // if (this.isProgrammaticNavigation) {
                    //     this.isProgrammaticNavigation = false; // Reset the flag
                    //     return; // Exit early for programmatic navigation
                    // }

                    if (window.location.href.indexOf('partspicker') === -1) {
                        window.navigation.removeEventListener("navigate", myCallback)
                        return;
                    }
                    //If this fires then we have navigated off the parts picker page
                    // if (window.location.href.indexOf('partspickernew') > -1) {
                    //     self.url = window.location.href;
                    // }else {#

                    let originalHash = event.oldURL.split('#')[1] ;
                    let originalHashSplit = originalHash.split('&').reduce(function (res, item) {
                        let parts = item.split('=');
                        res[parts[0]] = parts[1];
                        return res;
                    }, {});

                    console.log({event})
                    let hash = window.location.hash.substr(1)

                    // console.log("Hash events", {originalHashSplit: originalHashSplit, hash: hash, windowLocation: window.location.href, eventLocation: event.destination.url})

                    if(hash) {
                        let hashSplit = hash.split('&').reduce(function (res, item) {
                            let parts = item.split('=');
                            res[parts[0]] = parts[1];
                            return res;
                        }, {});

                        console.log("Hash changing",{
                            hash: hash,
                            hashSplit: hashSplit,
                            originalHash: originalHash,
                            originalHashSplit: originalHashSplit
                        })
                        // if ((originalHashSplit.area === hashSplit.area) && !hashSplit.page) {
                        //     hashSplit.area = ""
                        // }
                        const url = event.oldURL;
                        const lastPart = url.substr(url.lastIndexOf('/') + 1);
                        let pageUrl = window.location.href;
                        pageUrl = pageUrl.split('#')[0]
                        pageUrl += `#type=${encodeURIComponent(hashSplit.type)}&brand=${encodeURIComponent(hashSplit.brand)}&model=${encodeURIComponent(hashSplit.model)}`
                        // If the last part of the URL is "partspicker", then push the history so the back button works
                        if (hashSplit.type !== originalHashSplit.type || hashSplit.brand !== originalHashSplit.brand || hashSplit.model !== originalHashSplit.model) {
                            let ppPicker = new MaxaPartPickerCollection()
                            hashSplit.customerCurrency = this.currency
                            hashSplit.priceLevel = this.priceLevel
                            ppPicker.fetch({
                                data: hashSplit
                            }).done(function (result) {
                                self.totalCollection = result
                                self.totalItems = result.items

                                let totalItems = [...result.items]
                                let facets = []
                                result.areas.forEach(function (facet) {
                                    facet.url = window.location + "&area=" + facet.id
                                    facets.push(facet)
                                })
                                if (hashSplit.instock) {
                                    let boolValue = (hashSplit.instock === "true")
                                    if (boolValue) {
                                        totalItems = totalItems.filter(item => item.instock === boolValue)
                                    }
                                }

                                if (hashSplit.area) {
                                    totalItems = totalItems.filter(item => item.custitem_scamax001_area.split(', ').includes(hashSplit.area.toString()))
                                    facets.forEach(item => {
                                        item.selected = item.id === hashSplit.area;
                                    })
                                }

                                if (hashSplit.sortby) {
                                    totalItems = self.sortArray(totalItems, hashSplit.sortby)
                                } else {
                                    totalItems = result.items.sort((a, b) => {
                                        const aRank = a.custitem_scamax001_sca_ranking || Infinity
                                        const bRank = b.custitem_scamax001_sca_ranking || Infinity
                                        return aRank - bRank
                                    })
                                }
                                let pages = []
                                if (hashSplit.page) {
                                    const lowScale = (hashSplit.page === 1) ? 0 : self.pageSize * (hashSplit.page - 1);
                                    self.collection = totalItems.splice(lowScale, self.pageSize)
                                    self.currentPage = parseInt(hashSplit.page)
                                    const thisPages = Math.ceil(totalItems.length / self.pageSize)
                                    for (var i = 0; i < thisPages; i++) {
                                        var obj = {}
                                        obj.pageNumber = i + 1
                                        obj.href = window.location + "&page=" + (i + 1)
                                        obj.selected = (i === (parseInt(hashSplit.page)) - 1);
                                        pages.push(obj)
                                    }
                                    self.backButton = (parseInt(hashSplit.page) === 1)
                                    self.nextButton = (parseInt(hashSplit.page) === thisPages || pages.length === 1)
                                } else {
                                    const thisPages = Math.ceil(result.items.length / self.pageSize)
                                    self.collection = totalItems.slice(0, self.pageSize)
                                    self.currentPage = 1
                                    for (var i = 0; i < thisPages; i++) {
                                        var obj = {}
                                        obj.pageNumber = i + 1
                                        obj.href = window.location + "&page=" + (i + 1)
                                        obj.selected = (i === 0);
                                        pages.push(obj)
                                    }
                                    self.backButton = true
                                    self.nextButton = (pages.length === 1)
                                }


                                self.facets = facets
                                self.pages = pages
                                self.type = result.partsPicker[0].typename
                                self.brand = result.partsPicker[0].brandname
                                self.model = result.partsPicker[0].modelname
                                // var application = require('Application');
                                // application.getLayout().updateBreadcrumbs(self.getBreadcrumbPages());
                                self.image = result.partsPicker[0].imageurl
                                self.backButtonUrl = window.location + "&page=back"
                                self.nextButtonUrl = window.location + "&page=next"
                                self.render()
                            })
                        }

                        //console.log("Hash", {new: hashSplit, old: originalHashSplit, pageUrl: pageUrl})
                        //User has tried to click off of
                        if ((hashSplit.area === originalHashSplit.area) && !hashSplit.instock && !hashSplit.sortby && !hashSplit.page) {
                            let totalItems = [...self.totalItems]
                            self.facets.forEach(item => {
                                item.selected = false;
                            })
                            let url = window.location.href;
                            url = url.split('#')[0]
                            url += "#type=" + hashSplit.type + "&brand=" + hashSplit.brand + "&model=" + hashSplit.model
                            if (originalHashSplit.instock) {
                                let boolValue = (originalHashSplit.instock === "true")
                                if (boolValue) {
                                    totalItems = totalItems.filter(item => item.instock === boolValue)
                                    url += "&instock=" + boolValue
                                }
                            }
                            if (originalHashSplit.sortby) {
                                url += "&sortby=" + originalHashSplit.sortby
                                totalItems = this.sortArray(totalItems, originalHashSplit.sortby);
                            }

                            if (originalHashSplit.pageSize) {
                                url += "&pageSize=" + originalHashSplit.pageSize
                            }
                            const thisPages = Math.ceil(totalItems.length / self.pageSize)

                            self.collection = totalItems.splice(0, self.pageSize)

                            let pages = []
                            for (var i = 0; i < thisPages; i++) {
                                var obj = {}
                                obj.pageNumber = i + 1
                                obj.href = pageUrl + "&page=" + (i + 1)
                                obj.selected = (i === 0);
                                pages.push(obj)
                            }
                            self.pages = pages
                            self.currentPage = 1
                            //True means dont show and false means show
                            self.backButton = true
                            self.nextButton = (thisPages === 1)

                            //Update the history. This function stops the callback from getting stuck in a loop
                            this.updateHistory(url)
                            self.render()
                        }
                        //If there was no area to start with and now there is an area go in here
                        //If there was an area and there is one, but they are not the same go in here
                        if ((!originalHashSplit.area && hashSplit.area) || ((originalHashSplit.area && hashSplit.area) && (originalHashSplit.area !== hashSplit.area))) {
                            //Make a copy of total items because if we declared it to be equal to self.totalitems it would
                            //inadvertently override self.totalitems
                            let totalItems = [...self.totalItems]

                            //Filter the results based on the area selected
                            totalItems = totalItems.filter(item => item.custitem_scamax001_area.split(', ').includes(hashSplit.area.toString()))
                            //Set the area to be selected so this is highlighted in orange
                            let selectedFacet = 0
                            self.facets.forEach((item, index) => {
                                item.selected = item.id === hashSplit.area;
                                if (item.id === hashSplit.area) {
                                    selectedFacet = index
                                }
                            })

                            if (selectedFacet > 0) {
                                let facets = [...self.facets]
                                const element = facets.splice(selectedFacet, 1)[0]
                                facets.splice(0, 0, element)
                                self.facets = facets
                            }

                            //Create the URL that is to be pushed to the history so the back button but works as expected
                            let url = window.location.href;
                            url = url.split('#')[0]
                            url += "#type=" + hashSplit.type + "&brand=" + hashSplit.brand + "&model=" + hashSplit.model + "&area=" + hashSplit.area
                            if (originalHashSplit.sortby && !hashSplit.sortby) {
                                url += "&sortby=" + originalHashSplit.sortby
                                totalItems = this.sortArray(totalItems, originalHashSplit.sortby);
                            } else if (hashSplit.sortby) {
                                url += "&sortby=" + hashSplit.sortby
                                totalItems = this.sortArray(totalItems, hashSplit.sortby);
                            }

                            if (originalHashSplit.instock && !hashSplit.instock) {
                                let boolValue = (originalHashSplit.instock === "true")
                                if (boolValue) {
                                    totalItems = totalItems.filter(item => item.instock === boolValue)
                                    url += "&instock=" + boolValue
                                }
                            } else if (hashSplit.instock) {
                                let boolValue = (hashSplit.instock === "true")
                                if (boolValue) {
                                    totalItems = totalItems.filter(item => item.instock === boolValue)
                                    url += "&instock=" + boolValue
                                }
                            }

                            if (originalHashSplit.pageSize && !hashSplit.pageSize) {
                                url += "&pageSize=" + originalHashSplit.pageSize
                                self.pageSize = parseInt(originalHashSplit.pageSize)
                            } else if (hashSplit.pageSize) {
                                url += "&pageSize=" + hashSplit.pageSize
                                self.pageSize = parseInt(hashSplit.pageSize)
                            }

                            //calculate the number of pages for this area
                            const thisPages = Math.ceil(totalItems.length / self.pageSize)

                            self.collection = totalItems.splice(0, self.pageSize)

                            let pages = []
                            for (var i = 0; i < thisPages; i++) {
                                var obj = {}
                                obj.pageNumber = i + 1
                                obj.href = pageUrl + "&page=" + (i + 1)
                                obj.selected = (i === 0);
                                pages.push(obj)
                            }
                            self.pages = pages
                            self.currentPage = 1
                            //True means dont show and false means show
                            self.backButton = true
                            self.nextButton = (pages.length === 1)

                            //Update the history. This function stops the callback from getting stuck in a loop
                            this.updateHistory(url)
                            self.render()
                            return;
                        }
                        //If there was no sort to start with and now there is an sort go in here
                        //If there was a sort and there is one, but they are not the same go in here
                        if ((!originalHashSplit.sortby && hashSplit.sortby) || ((originalHashSplit.sortby && hashSplit.sortby) && (originalHashSplit.sortby !== hashSplit.sortby))) {
                            //Make a copy of total items because if we declared it to be equal to self.totalitems it would
                            //inadvertently override self.totalitems
                            let totalItems = [...self.totalItems]

                            //Create the url to be pushed to the history
                            let url = window.location.href;
                            url = url.split('#')[0]
                            url += `#type=${encodeURIComponent(hashSplit.type)}&brand=${encodeURIComponent(hashSplit.brand)}&model=${encodeURIComponent(hashSplit.model)}&sortby=${encodeURIComponent(hashSplit.sortby)}`
                            if (originalHashSplit.area && !hashSplit.area) {
                                totalItems = totalItems.filter(item => item.custitem_scamax001_area.split(', ').includes(originalHashSplit.area.toString()))
                                url += "&area=" + originalHashSplit.area
                                self.facets.forEach(item => {
                                    item.selected = item.id === originalHashSplit.area;
                                })
                            } else if (hashSplit.area) {
                                totalItems = totalItems.filter(item => item.custitem_scamax001_area.split(', ').includes(hashSplit.area.toString()))
                                url += "&area=" + hashSplit.area
                                self.facets.forEach(item => {
                                    item.selected = item.id === hashSplit.area;
                                })
                            }

                            if (originalHashSplit.instock && !hashSplit.instock) {
                                let boolValue = (originalHashSplit.instock === "true")
                                if (boolValue) {
                                    totalItems = totalItems.filter(item => item.instock === boolValue)
                                    url += "&instock=" + boolValue
                                }
                            } else if (hashSplit.instock) {
                                let boolValue = (hashSplit.instock === "true")
                                if (boolValue) {
                                    totalItems = totalItems.filter(item => item.instock === boolValue)
                                    url += "&instock=" + boolValue
                                }
                            }

                            if (originalHashSplit.pageSize && !hashSplit.pageSize) {
                                url += "&pageSize=" + originalHashSplit.pageSize
                                self.pageSize = parseInt(originalHashSplit.pageSize)
                            } else if (hashSplit.pageSize) {
                                url += "&pageSize=" + hashSplit.pageSize
                                self.pageSize = parseInt(hashSplit.pageSize)
                            }
                            totalItems = this.sortArray(totalItems, hashSplit.sortby)
                            const thisPages = Math.ceil(totalItems.length / self.pageSize)
                            self.collection = totalItems.splice(0, self.pageSize)
                            let pages = []
                            for (var i = 0; i < thisPages; i++) {
                                var obj = {}
                                obj.pageNumber = i + 1
                                obj.href = pageUrl + "&page=" + (i + 1)
                                obj.selected = (i === 0);
                                pages.push(obj)
                            }
                            self.pages = pages
                            self.currentPage = 1
                            self.backButton = true
                            self.nextButton = (pages.length === 1)
                            this.updateHistory(url)
                            self.render()
                        }

                        if ((!originalHashSplit.pageSize && hashSplit.pageSize) || ((originalHashSplit.pageSize && hashSplit.pageSize) && (originalHashSplit.pageSize !== hashSplit.pageSize))) {
                            let totalItems = [...self.totalItems]
                            let url = window.location.href;
                            url = url.split('#')[0]
                            url += `#type=${encodeURIComponent(hashSplit.type)}&brand=${encodeURIComponent(hashSplit.brand)}&model=${encodeURIComponent(hashSplit.model)}&pageSize=${encodeURIComponent(hashSplit.pageSize)}`
                            if (originalHashSplit.area && !hashSplit.area) {
                                totalItems = totalItems.filter(item => item.custitem_scamax001_area.split(', ').includes(originalHashSplit.area.toString()))
                                url += "&area=" + originalHashSplit.area
                                self.facets.forEach(item => {
                                    item.selected = item.id === originalHashSplit.area;
                                })
                            } else if (hashSplit.area) {
                                totalItems = totalItems.filter(item => item.custitem_scamax001_area.split(', ').includes(hashSplit.area.toString()))
                                url += "&area=" + hashSplit.area
                                self.facets.forEach(item => {
                                    item.selected = item.id === hashSplit.area;
                                })
                            }

                            if (originalHashSplit.sortby && !hashSplit.sortby) {
                                url += "&sortby=" + originalHashSplit.sortby
                                totalItems = this.sortArray(totalItems, originalHashSplit.sortby);
                            } else if (hashSplit.sortby) {
                                url += "&sortby=" + hashSplit.sortby
                                totalItems = this.sortArray(totalItems, hashSplit.sortby);
                            }

                            if (originalHashSplit.instock && !hashSplit.instock) {
                                let boolValue = (originalHashSplit.instock === "true")
                                if (boolValue) {
                                    totalItems = totalItems.filter(item => item.instock === boolValue)
                                    url += "&instock=" + boolValue
                                }
                            } else if (hashSplit.instock) {
                                let boolValue = (hashSplit.instock === "true")
                                if (boolValue) {
                                    totalItems = totalItems.filter(item => item.instock === boolValue)
                                    url += "&instock=" + boolValue
                                }
                            }
                            self.pageSize = Number(hashSplit.pageSize)
                            const thisPages = Math.ceil(totalItems.length / self.pageSize)
                            self.collection = totalItems.splice(0, self.pageSize)
                            let pages = []
                            for (var i = 0; i < thisPages; i++) {
                                var obj = {}
                                obj.pageNumber = i + 1
                                obj.href = pageUrl + "&page=" + (i + 1)
                                obj.selected = (i === 0);
                                pages.push(obj)
                            }
                            self.pages = pages
                            self.currentPage = 1
                            self.backButton = true
                            self.nextButton = (pages.length === 1)
                            this.updateHistory(url)
                            self.render()
                        }

                        if ((!originalHashSplit.instock && hashSplit.instock) || ((originalHashSplit.instock && hashSplit.instock) && (originalHashSplit.instock !== hashSplit.instock))) {
                            let totalItems = [...self.totalItems]
                            let url = window.location.href;
                            url = url.split('#')[0]
                            url += `#type=${encodeURIComponent(hashSplit.type)}&brand=${encodeURIComponent(hashSplit.brand)}&model=${encodeURIComponent(hashSplit.model)}&instock=${encodeURIComponent(hashSplit.instock)}`
                            if (originalHashSplit.area && !hashSplit.area) {
                                totalItems = totalItems.filter(item => item.custitem_scamax001_area.split(', ').includes(originalHashSplit.area.toString()))
                                url += "&area=" + originalHashSplit.area
                                self.facets.forEach(item => {
                                    item.selected = item.id === originalHashSplit.area;
                                })
                            } else if (hashSplit.area) {
                                totalItems = totalItems.filter(item => item.custitem_scamax001_area.split(', ').includes(hashSplit.area.toString()))
                                url += "&area=" + hashSplit.area
                                self.facets.forEach(item => {
                                    item.selected = item.id === hashSplit.area;
                                })
                            }

                            if (originalHashSplit.sortby && !hashSplit.sortby) {
                                url += "&sortby=" + originalHashSplit.sortby
                                totalItems = this.sortArray(totalItems, originalHashSplit.sortby);
                            } else if (hashSplit.sortby) {
                                url += "&sortby=" + hashSplit.sortby
                                totalItems = this.sortArray(totalItems, hashSplit.sortby);
                            }

                            if (originalHashSplit.pageSize && !hashSplit.pageSize) {
                                url += "&pageSize=" + originalHashSplit.pageSize
                                self.pageSize = parseInt(originalHashSplit.pageSize)
                            } else if (hashSplit.pageSize) {
                                url += "&pageSize=" + hashSplit.pageSize
                                self.pageSize = parseInt(hashSplit.pageSize)
                            }

                            let boolValue = (hashSplit.instock === "true")
                            if (boolValue) {
                                totalItems = totalItems.filter(item => item.instock === boolValue)
                            }
                            const thisPages = Math.ceil(totalItems.length / self.pageSize)
                            self.collection = totalItems.splice(0, self.pageSize)
                            let pages = []
                            for (var i = 0; i < thisPages; i++) {
                                var obj = {}
                                obj.pageNumber = i + 1
                                obj.href = pageUrl + "&page=" + (i + 1)
                                obj.selected = (i === 0);
                                pages.push(obj)
                            }
                            self.pages = pages
                            self.currentPage = 1
                            self.backButton = true
                            self.nextButton = false
                            this.updateHistory(url)
                            self.render()
                        }

                        if ((!originalHash.page && hashSplit.page) || ((originalHashSplit.page && hashSplit.page) && (originalHashSplit !== hashSplit.page))) {
                            //Page has changed
                            let currentPage = (hashSplit.page === "next") ? self.currentPage + 1 : (hashSplit.page === "back") ? self.currentPage - 1 : hashSplit.page
                            const pageTotal = self.pageSize
                            const lowScale = (currentPage === 1) ? 0 : pageTotal * (currentPage - 1);
                            let totalItems = [...self.totalItems]
                            let url = window.location.href;
                            url = url.split('#')[0]
                            url += "#type=" + hashSplit.type + "&brand=" + hashSplit.brand + "&model=" + hashSplit.model + "&page=" + currentPage
                            if (originalHashSplit.area && !hashSplit.area) {
                                totalItems = self.totalCollection.items.filter(item => item.custitem_scamax001_area.split(', ').includes(originalHashSplit.area.toString()))
                                url += "&area=" + originalHashSplit.area
                                self.facets.forEach(item => {
                                    item.selected = item.id === originalHashSplit.area;
                                })
                            } else if (hashSplit.area) {
                                totalItems = self.totalCollection.items.filter(item => item.custitem_scamax001_area.split(', ').includes(hashSplit.area.toString()))
                                url += "&area=" + hashSplit.area
                                self.facets.forEach(item => {
                                    item.selected = item.id === hashSplit.area;
                                })

                            }
                            if (originalHashSplit.sortby && !hashSplit.sortby) {
                                url += "&sortby=" + originalHashSplit.sortby
                                totalItems = this.sortArray(totalItems, originalHashSplit.sortby);
                            } else if (hashSplit.sortby) {
                                url += "&sortby=" + hashSplit.sortby
                                totalItems = this.sortArray(totalItems, hashSplit.sortby);
                            }
                            if (originalHashSplit.instock && !hashSplit.instock) {
                                let boolValue = (originalHashSplit.instock === "true")
                                if (boolValue) {
                                    totalItems = totalItems.filter(item => item.instock === boolValue)
                                    url += "&instock=" + boolValue
                                }
                            } else if (hashSplit.instock) {
                                let boolValue = (hashSplit.instock === "true")
                                if (boolValue) {
                                    totalItems = totalItems.filter(item => item.instock === boolValue)
                                    url += "&instock=" + boolValue
                                }
                            }

                            if (originalHashSplit.pageSize && !hashSplit.pageSize) {
                                url += "&pageSize=" + originalHashSplit.pageSize
                                self.pageSize = parseInt(originalHashSplit.pageSize)
                            } else if (hashSplit.pageSize) {
                                url += "&pageSize=" + hashSplit.pageSize
                                self.pageSize = parseInt(hashSplit.pageSize)
                            }

                            const thisPages = Math.ceil(totalItems.length / self.pageSize)

                            self.pages.forEach(page => {
                                page.selected = (page.pageNumber.toString() === currentPage.toString())
                            })

                            totalItems = totalItems.splice(lowScale, self.pageSize)
                            self.collection = totalItems

                            this.updateHistory(url)
                            self.currentPage = currentPage
                            self.backButton = (currentPage === 1)
                            self.nextButton = (currentPage === thisPages)
                            self.render()
                        }
                    }else{
                        if (event.oldURL.indexOf('showinmodal') > -1) {
                            this.updateHistory(window.location.href)
                        }

                        if(event.oldURL.indexOf('partspicker') > -1){
                            this.updateHistory(window.location.href)
                        }
                    }

                }
                // window.navigation.addEventListener("navigate", myCallback)
                window.addEventListener("hashchange", myCallback)
                // window.addEventListener('hashchange', myCallback)
                this.updateHistory = function (newUrl) {
                    this.isProgrammaticNavigation = true;
                    history.pushState(null, null, newUrl);
                };
                

            }

            , sortArray: function sortArray(items, sort) {
                switch (sort) {
                    case "most-popular":
                        return items.sort((a, b) => {
                            const aRank = a.custitem_scamax001_sca_ranking || Infinity
                            const bRank = b.custitem_scamax001_sca_ranking || Infinity
                            return aRank - bRank
                        })
                    case "low-to-high":
                        return items.sort((a, b) => a.price - b.price)
                    case "high-to-low":
                        return items.sort((a, b) => b.price - a.price)
                    case "atoz":
                        return items.sort((a, b) => {
                            const nameA = a.storedisplayname || "";
                            const nameB = b.storedisplayname || "";

                            const isNumericA = !isNaN(parseInt(nameA[0], 10));
                            const isNumericB = !isNaN(parseInt(nameB[0], 10));

                            if (isNumericA && isNumericB) {
                                // Both start with numbers; sort numerically
                                return parseFloat(nameA) - parseFloat(nameB);
                            } else if (isNumericA) {
                                // `a` is numeric and `b` is not; `a` comes first
                                return -1;
                            } else if (isNumericB) {
                                // `b` is numeric and `a` is not; `b` comes first
                                return 1;
                            } else {
                                // Neither start with numbers; sort alphabetically
                                return nameA.localeCompare(nameB);
                            }
                        })
                    case "ztoa":
                        return items.sort((a, b) => {
                            const nameA = a.storedisplayname || "";
                            const nameB = b.storedisplayname || "";

                            const isNumericA = !isNaN(parseInt(nameA[0], 10));
                            const isNumericB = !isNaN(parseInt(nameB[0], 10));

                            if (!isNumericA && !isNumericB) {
                                // Both start with letters; sort alphabetically descending
                                return nameB.localeCompare(nameA);
                            } else if (!isNumericA) {
                                // `a` starts with a letter, `b` starts with a number; `a` comes first
                                return -1;
                            } else if (!isNumericB) {
                                // `b` starts with a letter, `a` starts with a number; `b` comes first
                                return 1;
                            } else {
                                // Both start with numbers; sort numerically descending
                                return parseFloat(nameB) - parseFloat(nameA);
                            }
                        });
                }
            }

            , beforeShowContent: function beforeShowContent() {
                var hash = window.location.hash.substr(1);
                var hashSplit = hash.split('&').reduce(function (res, item) {
                    var parts = item.split('=');
                    res[parts[0]] = parts[1];
                    return res;
                }, {});
                let self = this
                //hashSplit = {model:205, type:111, brand: 30, isNew: true}
                console.log("Profile Model PP", this.profile);

                hashSplit.isNew = true
                this.childViews = {
                    'MaxaPartPicker.Collection.View': function () {
                        return new BackboneCollectionView({
                            childTemplate: facets_items_collection_view_cell_tpl
                            , childView: FacetsItemCellView
                            , childViewOptions: {
                                application: this.application,
                                is_logged_in: this.is_logged_in
                            }
                            , viewsPerRow: 24
                            , collection: this.collection
                            , cellTemplate: facets_items_collection_view_cell_tpl
                            , rowTemplate: facets_items_collection_view_row_tpl
                            , template: facets_items_collection_tpl

                        });
                    },
                    'PartPickerSort': function () {
                        return new PartPickerSort({
                            pages: 3,
                            is_logged_in: this.is_logged_in

                        })
                    },
                    'PartPickerPagination': function () {
                        return new PartPickerPagination({
                            pages: 3
                        })
                    }
                }
                // if(sessionStorage.getItem('area')) {
                //     hashSplit = {models: 1, typeid: 1, brands: 1, area: 1}
                // }
                console.log("Hash Split", hashSplit);
                this.currency = 1
                this.priceLevel = 5
                if(this.isLoggedIn){
                    this.currency = this.profile.attributes.currency.internalid
                    this.priceLevel = this.profile.attributes.priceLevel
                }
                hashSplit.customerCurrency = this.currency
                hashSplit.priceLevel = this.priceLevel

                return this.collection.fetch({
                    data: hashSplit
                }).done(function (result) {
                    self.totalCollection = result
                    self.totalItems = result.items

                    let totalItems = [...result.items]
                    let facets = []
                    result.areas.forEach(function (facet) {
                        facet.url = window.location + "&area=" + facet.id
                        facets.push(facet)
                    })
                    if (hashSplit.instock) {
                        let boolValue = (hashSplit.instock === "true")
                        if (boolValue) {
                            totalItems = totalItems.filter(item => item.instock === boolValue)
                        }
                    }

                    if (hashSplit.area) {
                        totalItems = totalItems.filter(item => item.custitem_scamax001_area.split(', ').includes(hashSplit.area.toString()))
                        facets.forEach(item => {
                            item.selected = item.id === hashSplit.area;
                        })
                    }

                    if (hashSplit.sortby) {
                        totalItems = self.sortArray(totalItems, hashSplit.sortby)
                    } else {
                        totalItems = result.items.sort((a, b) => {
                            const aRank = a.custitem_scamax001_sca_ranking || Infinity
                            const bRank = b.custitem_scamax001_sca_ranking || Infinity
                            return aRank - bRank
                        })
                    }
                    self.pageSize = (hashSplit.pageSize) ? Number(hashSplit.pageSize) : 24
                    let pages = []
                    if (hashSplit.page) {
                        const lowScale = (hashSplit.page === 1) ? 0 : self.pageSize * (hashSplit.page - 1);
                        self.collection = totalItems.splice(lowScale, self.pageSize)
                        self.currentPage = parseInt(hashSplit.page)
                        const thisPages = Math.ceil(totalItems.length / self.pageSize)
                        for (var i = 0; i < thisPages; i++) {
                            var obj = {}
                            obj.pageNumber = i + 1
                            obj.href = window.location + "&page=" + (i + 1)
                            obj.selected = (i === (parseInt(hashSplit.page)) - 1);
                            pages.push(obj)
                        }
                        self.backButton = (parseInt(hashSplit.page) === 1)
                        self.nextButton = (parseInt(hashSplit.page) === thisPages)
                    } else {
                        const thisPages = Math.ceil(result.items.length / self.pageSize)
                        self.collection = totalItems.slice(0, self.pageSize)
                        self.currentPage = 1
                        for (var i = 0; i < thisPages; i++) {
                            var obj = {}
                            obj.pageNumber = i + 1
                            obj.href = window.location + "&page=" + (i + 1)
                            obj.selected = (i === 0);
                            pages.push(obj)
                        }
                        self.backButton = true
                        self.nextButton = false
                    }


                    self.facets = facets
                    self.pages = pages
                    self.type = result.partsPicker[0].typename
                    self.brand = result.partsPicker[0].brandname
                    self.model = result.partsPicker[0].modelname
                    self.image = result.partsPicker[0].imageurl
                    self.backButtonUrl = window.location + "&page=back"
                    self.nextButtonUrl = window.location + "&page=next"
                    self.render()
                })

            },


            getContext() {
                // document.title = "Parts Picker: " + this.type + " > " + this.brand + " > " + this.model
                if (this.startPosition) {
                    let facetLength = this.facets.length
                    if (facetLength > 7) {
                        if (this.startPosition > 10) {
                            this.startPosition = this.startPosition - 2
                        } else {
                            this.startPosition = 0
                        }
                    }
                }

                return {
                    showResults: true,
                    isEmptyList: false,
                    showItems: true,
                    facets: this.facets,
                    model: this.model,
                    brand: this.brand,
                    image: (this.image === undefined) ? false : this.image,
                    type: this.type,
                    startPosition: (this.startPosition) ? this.startPosition : 0,
                    pages: this.pages,
                    backButtonUrl: this.backButtonUrl,
                    nextButtonUrl: this.nextButtonUrl,
                    backButton: this.backButton,
                    nextButton: this.nextButton
                }
            }
        });
    });
